/* eslint-disable arrow-parens */
import React, { useContext, useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import a11yScrollableProps from "../../../constants/tabPanelProps/ayScrollableProps";
import ScrollTabPanel from "../../shared/tabPanelComponent/ScrollTabPanel";
// import CoreDataGrid from "./coreDataGrid/healthPlanCalculation/CoreDataGrid";
import VEBDataGrid from "./vebDataGrid/VebDataGrid";
import { AuthContext, UIContext } from "../../../contexts";
import { ADMIN_DASHBOARD_HEADER } from "../../../constants/caption/dashboardHeader";
import CoreDataGrid from "./coreDataGrid/CoreDataGrid";
import CoreDataGridV2 from "./coreDataGrid/CoreDataGridV2";
import useRouteParam from "../../../hooks/useRouteParam";
import { getPermissionsFromGroupOwner } from "../../../utils/getPermissionsFromGroupOwner";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
		// backgroundColor: theme.palette.background.paper
	}
}));

const PremiumRecalculationManagement = (): JSX.Element => {
	const classes = useStyles();
	const [value, setValue] = useState(0);
	const { setDashboardHeader } = useContext(UIContext);

	const handleLabelChange = (event: any, value: number) => {
		setValue(value);
	};

	const queryGroupNumber = useRouteParam("gn");
	const { user } = useContext(AuthContext);

	const premiumRecalculationPermission = user
		? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.premium_recalculation_menu.self
		: null;

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.premium_recalculation);
	}, [setDashboardHeader]);

	return (
		<div className="premium-recalculation-management-container" id="premium-recalculation-management-container">
			<div className="tab-panel-container" style={{ width: "auto" }}>
				<div className={classes.root + " glb-tab-panel-container"}>
					<Box sx={{ width: "100%" }}>
						<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
							<Tabs
								value={value}
								onChange={handleLabelChange}
								TabIndicatorProps={{
									style: {
										border: "none",
										backgroundColor: "#558b2f"
									}
								}}
								variant="scrollable"
								scrollButtons="auto"
								aria-label="scrollable auto tabs example"
								className="glb-tab-panel"
							>
								<Tab label={"Core Plans"} className="glb-tab-label" {...a11yScrollableProps(0)} />
								<Tab label={"VEB Plans"} className="glb-tab-label" {...a11yScrollableProps(1)} />
							</Tabs>
							<ScrollTabPanel value={value} index={0}>
								<div style={{ marginTop: 25 }}>
									{/* <CoreDataGrid /> */}
									<CoreDataGridV2 />
								</div>
							</ScrollTabPanel>
							<ScrollTabPanel value={value} index={1}>
								<div style={{ marginTop: 25 }}>
									<VEBDataGrid />
								</div>
							</ScrollTabPanel>
						</Box>
					</Box>
				</div>
			</div>
		</div>
	);
};

export default PremiumRecalculationManagement;
